module.exports = __webpack_public_path__ + "img/no-orders-image.07c40ad9.jpg";